<template>
    <div>
        <div class="grosses-table-header-actions table-header-actions">
            <table-sorter
                v-if="tableSortables.length > 0"
                :sortables="sortables"
                :current-sort="sortKey"
                :current-sort-direction="sortDirection"
                @sort="sort"
            />

            <table-search @clear="search = ''" v-model="search" v-if="searchable"/>
            <div v-else></div>
        </div>

        <div
            class="table grosses-table table-zebra"
            :class="{'table-clickable': clickable, 'table-hover': !clickable}"
        >
            <div class="header">
                <grosses-header v-for="header in columns" :key="header.key" :header="header"/>
            </div>
            <div class="body">
                <grosses-row
                    v-show="!row.hide_row"
                    v-for="row in rows"
                    :key="row.id"
                    :row="row"
                    :headers="columns"
                    :is-home="isHome"
                    @click="onRowClick"
                />
                <div class="no-search-results" v-show="noSearchResults">
                    <search-icon/>No records matched your search, please try again.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import headers from 'src/config/grosses-table-headers';
import find from 'lodash/find';
import GrossesRow from 'src/components/GrossesRow';
import GrossesHeader from 'src/components/GrossesHeader';
import TableSorter from 'src/components/TableSorter';
import TableSearch from 'src/components/TableSearch';
import Fuse from 'fuse.js';
import cl from 'src/util/cloudinary';
import eventBus from 'src/util/eventBus';

export default {
    props: {
        tableData: {
            type: Array,
            required: true,
            default: () => [],
        },
        tableHeaders: {
            type: Array,
            required: true,
            default: () => [],
        },
        tableSortables: {
            type: Array,
            required: false,
            default: () => [],
        },
        sortKey: {
            type: String,
            required: false,
        },
        sortDirection: {
            type: String,
            required: false,
            default: 'asc',
        },
        searchable: {
            type: Boolean,
            required: false,
            default: false,
        },
        sortable: {
            type: Boolean,
            required: false,
            default: true,
        },
        clickable: {
            type: Boolean,
            required: false,
            default: false,
        },
        isHome: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            search: '',
        };
    },
    components: {
        GrossesRow,
        GrossesHeader,
        TableSorter,
        TableSearch,
    },
    computed: {
        rows() {
            if (this.tableData.length === 0) {
                return [];
            }

            const current = find(headers, { key: this.sortKey });

            const searchTerm = this.search.trim();

            const rowIds = this.fuse
                .search(searchTerm)
                .map(id => parseInt(id, 10));

            if (!this.searchable) {
                return this.tableData;
            }

            return this.tableData.map(row => {
                row.hide_row =
                    searchTerm.length > 0 && rowIds.indexOf(row.id) === -1;

                return row;
            });
        },
        noSearchResults() {
            return (
                this.search.trim().length > 0 &&
                this.rows.filter(row => !row.hide_row).length === 0
            );
        },
        columns() {
            return this.tableHeaders.map(key => find(headers, { key }));
        },
        sortables() {
            return this.tableSortables.map(key => find(headers, { key }));
        },
        fuse() {
            return new Fuse(this.tableData, {
                threshold: 0.3,
                keys: ['show.name'],
                id: 'id',
            });
        },
    },
    methods: {
        sort(newKey) {
            if (newKey === false) {
                return;
            }

            this.$emit('sort', { newKey });
            eventBus.$emit('sort', { newKey });
        },
        onRowClick(row) {
            this.$emit('rowClick', row);
        },
    },
};
</script>
